import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Spinner from '../ui/Spinner';
import { useAuth } from '../../context/AuthContext';

// Requires an authenticated admin (server-provided isAdmin from /api/me).
// Waits for the auth check to settle, then fails closed for non-admins.
// The server also enforces requireAdmin — this is UX, not the security boundary.
export default function AdminRoute() {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="ss-container" style={{ paddingBlock: 'var(--ss-space-8)', textAlign: 'center' }}>
        <Spinner label="Checking access" />
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
